// © 2025 COPYright LAHO – https://www.linkedin.com/in/laurens-holtkamp-7a686b2b/
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { describeClickedElement, trackAnalyticsEvent } from '../services/analyticsService';

export default function useAnalyticsTracking(user, group) {
  const location = useLocation();
  const lastPath = useRef('');

  useEffect(() => {
    if (!user?.id) return;
    const path = `${location.pathname}${location.search || ''}`;
    if (lastPath.current === path) return;
    lastPath.current = path;

    trackAnalyticsEvent({
      eventName: 'page_view',
      user,
      groupId: group?.id || null,
      metadata: { path },
    });
  }, [group?.id, location.pathname, location.search, user]);

  useEffect(() => {
    if (!user?.id) return;

    const onClick = (event) => {
      const clicked = describeClickedElement(event.target);
      if (!clicked) return;
      trackAnalyticsEvent({
        eventName: 'button_click',
        user,
        groupId: group?.id || null,
        metadata: clicked,
      });
    };

    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, [group?.id, user]);
}
